import { render } from "./GridParteneriDetaliiComercial.vue?vue&type=template&id=824ed716&scoped=true&ts=true"
import script from "./GridParteneriDetaliiComercial.vue?vue&type=script&lang=ts"
export * from "./GridParteneriDetaliiComercial.vue?vue&type=script&lang=ts"

import "./GridParteneriDetaliiComercial.vue?vue&type=style&index=0&id=824ed716&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-824ed716"]])

export default __exports__